/* eslint-disable */
import React from "react";
import { TextField } from '@material-ui/core'
import _ from 'lodash';
import { LeftListItem, LeftListItemSelected } from "./Base";
import { Link } from "react-router-dom";

export const handleFilter = _.debounce((val, props) => {
  const all = props.Session.RX_Board.all().toModelArray()
  all.map(item => {
    props.upsert({
      model: "RX_Board",
      payload: {
        searchVisible: false,
        active: false,
        id: item.id
      }
    });
  })
  if (!val || val.length === 0) return null;
  const arr = props.Session.RX_Board.filter(x => x.name.toLowerCase().includes(val) && !x.type.includes('Settings') && x.url !== null && x.url !== undefined && x.status === 'Active').toModelArray();
  arr.map(item => {
    props.upsert({
      model: "RX_Board",
      payload: {
        searchVisible: true,
        id: item.id
      }
    });
  })

}, 500)

export const Tree = function(props) {
  let tree = props.tree;
  let searchedFiles = props.Session.RX_Board.filter(x => x.searchVisible).toModelArray()

  if (!tree) return <div />;

  return (
    <React.Fragment>
      <TextField 
      fullWidth 
      placeholder="Search" 
      style={{ margin: '10px 20px 10px 20px', width: 'calc(100% - 40px)' }}
      onChange={e => handleFilter(e.target.value.toLowerCase(), props)}
      />
      { searchedFiles && searchedFiles.length > 0 ? (
        searchedFiles.map((item, index) => {
          return (
            <div key={index}>
              <Link to={"/dashboard/" + item.url} title={item.definition} onClick={() => handleFilter(null, props)}>
                <LeftListItem>
                  <span
                    style={{ width: "25px" }}
                    className={`fa fa-${item.icon}`}
                  />
                  {item.name}
                </LeftListItem>
              </Link>
            </div>
          )
        })
      ) : (
        <div style={props.style}>
          <Folders {...props} folders={tree.folders} />
          <Files {...props} files={tree.files} />
        </div>
        )
      }
    </React.Fragment>
  );
};

export class Folder extends React.Component {
  toggleCollapse(props, folder) {
    return props.upsert({
      model: "RX_Folder",
      payload: {
        collapsed: folder.collapsed ? false : true,
        id: folder.id
      }
    });
  }
  render() {
    let folder = this.props.folder;

    if (!folder) return <div />;
    else if (folder.module.hide) return <div />;
    else if (folder.module.collapsed)
      return (
        <div style={this.props.style} title={folder.module.definition}>
          <LeftListItem
            style={{ marginLeft: "0px" }}
            onClick={() => this.toggleCollapse(this.props, folder.module)}
          >
            <span
              style={{ marginRight: "5px", width: "20px" }}
              className={`fa fa-folder-o`}
            />
            {folder.module.label}
          </LeftListItem>
        </div>
      );
    else
      return (
        <div style={this.props.style} title={folder.module.definition}>
          <LeftListItem
            style={{ marginLeft: "0px" }}
            onClick={() => this.toggleCollapse(this.props, folder.module)}
          >
            <span
              style={{ marginRight: "5px", width: "20px" }}
              className={`fa fa-folder-open-o`}
            />
            {folder.module.label}
          </LeftListItem>
          <Folders {...this.props} folders={folder.folders} />
          <Files {...this.props} files={folder.files} />
        </div>
      );
  }
}

export const Folders = function(props) {
  let folders = props.folders.sort((a,b) => a.module.name.localeCompare(b.module.name));

  if (!folders) return <div />;
  return (
    <div>
      {folders.map((child, index) => {
        return (
          <Folder
            key={index}
            style={{ paddingLeft: "10px" }}
            {...props}
            folder={child}
          />
        );
      })}
    </div>
  );
};

export const Files = function(props) {
  let files = props.files.sort((a,b) => a.module.name.localeCompare(b.module.name));
  if (!files) return <div />;
  return (
    <div>
      {files.map((child, index) => {
        return child.module.status === 'Active' && <File key={index} {...props} file={child} />;
      })}
    </div>
  );
};

export const File = function(props) {
  const url = props.match.params.name;
  let file = props.file;
  if (!file) return <div />;
  return (
    <Link to={"/dashboard/" + file.module.url} title={file.module.definition}>
      {file.module.url === url ? (
        <LeftListItemSelected>
          <span
            style={{ width: "25px" }}
            className={`fa fa-${file.module.icon}`}
          />
          {file.module.name}
        </LeftListItemSelected>
      ) : (
        <LeftListItem>
          <span
            style={{ width: "25px" }}
            className={`fa fa-${file.module.icon}`}
          />
          {file.module.name}
        </LeftListItem>
      )}
    </Link>
  );
};



// WEBPACK FOOTER //
// ./src/components/Sidebar.js